module.exports = __webpack_public_path__ + "static/media/Viktor Krum 1.32971a18.jpg";